import { render, staticRenderFns } from "./indexExpert.vue?vue&type=template&id=387008b7&scoped=true"
import script from "./indexExpert.vue?vue&type=script&lang=js"
export * from "./indexExpert.vue?vue&type=script&lang=js"
import style0 from "./indexExpert.vue?vue&type=style&index=0&id=387008b7&prod&scoped=true&lang=css"
import style1 from "./indexExpert.vue?vue&type=style&index=1&id=387008b7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387008b7",
  null
  
)

export default component.exports